import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostTitleInterface } from 'common/types/entities/BlogPostTitleInterface'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createBlogPostTitle(
  parentId: string,
  masterBlockId?: MasterBlockId,
): BlogPostTitleInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.BlogPostTitle,
      parentId,
      masterBlockId,
    ),
    fontSize: 27,
    color: 'rgba(0, 0, 0, 1)',
    mobileFontSize: 20,
    alignSelf: 'center',
  }
}
